<script lang="ts">
  // Slim, dismissible top strip advertising the free Beta phase. Renders only
  // when the runtime flag is on; dismissal is remembered in localStorage so it
  // stays hidden across navigations/reloads.
  import { Link } from "svelte-routing";
  import { betaEnabled } from "./beta";

  const STORAGE_KEY = "wd-beta-banner-dismissed";

  let dismissed = false;
  try {
    dismissed = localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    /* localStorage unavailable (private mode) — show the banner */
  }

  function dismiss(): void {
    dismissed = true;
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      /* ignore — banner stays hidden for this session regardless */
    }
  }
</script>

{#if $betaEnabled && !dismissed}
  <div class="beta-banner" role="region" aria-label="Beta-Phase" data-testid="beta-banner">
    <div class="wrap beta-banner__in">
      <p class="beta-banner__text">
        <strong>Beta-Phase:</strong> Wir hosten den Server gerade kostenlos und
        suchen Tester:innen.
        <Link to="/beta" class="beta-banner__cta">Jetzt mitmachen →</Link>
      </p>
      <button
        class="beta-banner__close"
        type="button"
        aria-label="Hinweis schließen"
        on:click={dismiss}
        data-testid="beta-banner-close"
      >
        ×
      </button>
    </div>
  </div>
{/if}

<style>
  .beta-banner {
    background: var(--primary);
    color: var(--on-primary);
  }
  .beta-banner__in {
    display: flex;
    align-items: center;
    gap: 14px;
    padding-block: 9px;
  }
  .beta-banner__text {
    margin: 0;
    flex: 1;
    font-size: 14.5px;
    line-height: 1.45;
  }
  .beta-banner :global(.beta-banner__cta) {
    color: var(--on-primary);
    font-weight: 700;
    text-decoration: underline;
    text-underline-offset: 2px;
    white-space: nowrap;
  }
  .beta-banner :global(.beta-banner__cta:hover) {
    opacity: 0.85;
  }
  .beta-banner__close {
    appearance: none;
    background: transparent;
    border: 0;
    color: var(--on-primary);
    font-size: 22px;
    line-height: 1;
    padding: 2px 6px;
    cursor: pointer;
    border-radius: 8px;
    opacity: 0.85;
  }
  .beta-banner__close:hover {
    opacity: 1;
    background: rgba(255, 255, 255, 0.18);
  }
</style>
